frappe.ready(function () {
	// One-time migration: an earlier version of pwahq_boot.js registered its
	// service worker unconditionally on every page, including plain desktop
	// website visits. This left stale "pwahq-*" caches and SW registrations
	// behind for those visitors. Run this cleanup once per browser (not on
	// every page load — that previously raced with pwahq_boot.js re-registering
	// the SW and threw "Only the active worker can claim clients"), then never
	// run again so the SW that's supposed to be active (mobile/standalone/desk)
	// isn't fought on every navigation.
	if (typeof window === "undefined" || !window.location || !window.location.pathname) {
		return;
	}

	var isDesk = window.location.pathname.indexOf("/app") === 0;
	if (isDesk) {
		return;
	}

	var MIGRATION_KEY = "raftor_pwahq_sw_cleanup_v2";
	try {
		if (window.localStorage && localStorage.getItem(MIGRATION_KEY) === "1") {
			return;
		}
	} catch (_) {
		return;
	}

	if ("serviceWorker" in navigator && navigator.serviceWorker.getRegistrations) {
		navigator.serviceWorker
			.getRegistrations()
			.then(function (registrations) {
				return Promise.all(
					(registrations || []).map(function (registration) {
						return registration.unregister().catch(function () {
							return null;
						});
					})
				);
			})
			.catch(function () {
				return null;
			});
	}

	if ("caches" in window && caches.keys) {
		caches
			.keys()
			.then(function (keys) {
				return Promise.all(
					(keys || [])
						.filter(function (key) {
							return key && key.indexOf("pwahq-") === 0;
						})
						.map(function (key) {
							return caches.delete(key).catch(function () {
								return false;
							});
						})
				);
			})
			.catch(function () {
				return null;
			});
	}

	try {
		localStorage.setItem(MIGRATION_KEY, "1");
	} catch (_) {}
});
